import type { ForeignEntityId } from "../handles/foreignEntityId";
import type { FramingComponentType } from "./framingComponentTypes";
import type { IJoistProfileDescriptor } from "./iJoistTypes";
import type { LumberProfileDescriptor } from "./lumberTypes";

export enum FramingProfileSectionKind {
  DIMENSIONAL = "DIMENSIONAL",
  COMPOSITE = "COMPOSITE",
  I_JOIST = "I_JOIST",
  TRUSS = "TRUSS",
  CUSTOM = "CUSTOM",
}

export type RectangularFramingProfileSectionKind =
  | FramingProfileSectionKind.COMPOSITE
  | FramingProfileSectionKind.TRUSS
  | FramingProfileSectionKind.CUSTOM;

interface FramingProfileDescriptorBase {
  readonly componentId: ForeignEntityId<"FRAMING_COMPONENT">;
  readonly name: string;
  readonly annotationLabel: string;
  readonly width: number;
  readonly height: number;
}

export interface DimensionalFramingProfileDescriptor extends FramingProfileDescriptorBase {
  readonly sectionKind: FramingProfileSectionKind.DIMENSIONAL;
  readonly componentType: FramingComponentType.DIMENSIONAL_LUMBER;
  readonly componentDescriptor: LumberProfileDescriptor;
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface IJoistFramingProfileDescriptor extends FramingProfileDescriptorBase {
  readonly sectionKind: FramingProfileSectionKind.I_JOIST;
  readonly componentType: FramingComponentType.I_JOIST;
  readonly componentDescriptor: IJoistProfileDescriptor;
}

export interface RectangularFramingProfileDescriptor extends FramingProfileDescriptorBase {
  readonly sectionKind: RectangularFramingProfileSectionKind;
  readonly componentType:
    | FramingComponentType.COMPOSITE_LUMBER
    | FramingComponentType.TRUSS
    | FramingComponentType.CUSTOM;
}

export type FramingProfileDescriptor =
  | DimensionalFramingProfileDescriptor
  | IJoistFramingProfileDescriptor
  | RectangularFramingProfileDescriptor;
